import { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import "../styles/Profile.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "react-toastify";
import emailjs from "@emailjs/browser";
function Profile() {
  const [profile, setProfile] = useState(null);
  const [profileImageUrl, setProfileImageUrl] = useState("https://www.pngmart.com/files/23/Profile-PNG-Photo.png");
  const [trips, setTrips] = useState([]);
  const [expandedTrip, setExpandedTrip] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [deletePrompt, setDeletePrompt] = useState(null);
  const [message, setMessage] = useState(null);
  const [currentTripIndex, setCurrentTripIndex] = useState(0);
  const [currentBookingIndex, setCurrentBookingIndex] = useState(0);
  const [vlogs, setVlogs] = useState([]);
  const [vlogsPage, setVlogsPage] = useState(0);
  const [bookings, setBookings] = useState([]);

  const [currentVlogIndex, setCurrentVlogIndex] = useState(0);
  const [showComments, setShowComments] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editForm, setEditForm] = useState({
    id: "",
    title: "",
    description: "",
    file: null,
    previewUrl: ""
  });

  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showDateModal, setShowDateModal] = useState(false);
  const [newDate, setNewDate] = useState("");
  const [acceptTerms, setAcceptTerms] = useState(false);
  const navigate = useNavigate();
  const { loggedIn, user: authUser, loading: authLoading, fetchWithAuth } = useAuth();
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    if (!authLoading && !loggedIn) {
      navigate("/login");
      return;
    }

    if (authUser) setProfile(authUser);

    const fetchProfileData = async () => {
      try {
        setLoading(true);
        setError(null);

        // Fetch Profile
        const profileRes = await fetchWithAuth(`${API_URL}/profile`);
        if (!profileRes.ok) {
          if (profileRes.status === 401) navigate("/login");
          throw new Error("Failed to fetch profile");
        }
        const profileData = await profileRes.json();
        setProfile(profileData.user);

        // Fetch Profile Image
        fetchProfileImage(profileData.user.email);

        // Fetch Saved Trips
        const tripsRes = await fetchWithAuth(`${API_URL}/get-saved-trips`);
        if (tripsRes.ok) {
          const tripsData = await tripsRes.json();
          setTrips(tripsData.trips || []);
        } else setTrips([]);
        const bookingsRes = await fetchWithAuth(`${API_URL}/get-user-bookings`);
        if (bookingsRes.ok) {
          const bookingsData = await bookingsRes.json();
          setBookings(bookingsData.bookings || []);
        } else {
          setBookings([]);
        }
        // Fetch User Vlogs
        fetchUserVlogs(profileData.user.email, 0);
      } catch (err) {
        console.error(err);
        setError("Failed to load profile data");
      } finally {
        setLoading(false);
      }
    };

    if (loggedIn) fetchProfileData();
  }, [loggedIn, authLoading, authUser, navigate, fetchWithAuth, API_URL]);

  const fetchProfileImage = async (userEmail) => {
    try {
      const res = await fetchWithAuth(`${API_URL}/profile-image?userEmail=${userEmail}`);
      if (res.ok) {
        const data = await res.json();
        if (data.profileImageUrl) setProfileImageUrl(data.profileImageUrl);
      }
    } catch (err) {
      console.error("Error fetching profile image:", err);
    }
  };

  const handleProfileImageChange = async (file) => {
    if (!file) return;
    try {
      const formData = new FormData();
      formData.append("profileImage", file);
      formData.append("userEmail", profile.email);

      const res = await fetch(`${API_URL}/profile-image`, {
        method: "POST",
        body: formData,
      });

      if (!res.ok) throw new Error("Failed to update profile image");

      const data = await res.json();
      if (data.profileImageUrl) setProfileImageUrl(data.profileImageUrl);
      toast.success("🧑‍🏫 profile updated successfully");
    } catch (err) {
      console.error(err);
      toast.error("Failed to update profile image");
    }
  };

  const handleDeleteClick = (tripId) => setDeletePrompt(tripId);
  const handleConfirmDelete = async (tripId) => {
    try {
      const res = await fetchWithAuth(`${API_URL}/delete-trip/${tripId}`, { method: "DELETE" });
      if (!res.ok) {
        const errData = await res.json();
        setMessage({ type: "error", text: errData.error || "Failed to delete trip" });
        setTimeout(() => setMessage(null), 4000);
        return;
      }
      setTrips((prev) => prev.filter((trip) => trip._id !== tripId));
      toast.success("🏖️ trip deleted successfully");
      setTimeout(() => setMessage(null), 4000);
    } catch (err) {
      console.error(err);
      toast.error("Error in deleting trip, try again");
      setTimeout(() => setMessage(null), 4000);
    } finally {
      setDeletePrompt(null);
    }
  };
  const handleCancelDelete = () => setDeletePrompt(null);

  const fetchUserVlogs = async (userEmail, page = 0) => {
    try {
      const res = await fetchWithAuth(
        `${API_URL}/get-user-vlogs?userEmail=${userEmail}&page=${page}&limit=4`
      );
      if (!res.ok) throw new Error("Failed to fetch vlogs");
      const data = await res.json();
      if (page === 0) setVlogs(data.vlogs);
      else setVlogs((prev) => [...prev, ...data.vlogs]);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchVlogComments = async (vlogId) => {
    try {
      const res = await fetchWithAuth(`${API_URL}/vlogs/${vlogId}/comments`);
      if (!res.ok) throw new Error("Failed to fetch comments");
      const data = await res.json();
      return data.comments || [];
    } catch (err) {
      console.error("Error fetching comments:", err);
      return [];
    }
  };
  const handleToggleComments = async (index) => {
    if (showComments === index) {
      setShowComments(null); // hide if already open
      return;
    }
    console.log(index, vlogs[index]);
    const vlog = vlogs[index];
    const comments = await fetchVlogComments(vlog._id);
    console.log("Comments", comments);
    // Update the vlog in state with fetched comments
    setVlogs((prevVlogs) => {
      const newVlogs = [...prevVlogs];
      newVlogs[index] = { ...vlog, comments };
      return newVlogs;
    });
    console.log(vlogs);
    setShowComments(index);
  };
  // DELETE
  const handleDeleteVlog = async (vlogId) => {
    if (!window.confirm("Are you sure you want to delete this vlog?")) return;

    try {
      const res = await fetchWithAuth(`${API_URL}/delete-vlog/${vlogId}`, {
        method: "DELETE"
      });

      if (!res.ok) throw new Error("Failed to delete vlog");

      setVlogs((prev) => prev.filter((v) => v._id !== vlogId));
      toast.info("🎥 Vlog deleted successfully");
    } catch (err) {
      console.error(err);
      toast.error("Can't delete the vlog, try again");
    }
  };

  // EDIT (simple title/description update for now)
  const handleEditVlog = (vlog) => {
    setEditForm({
      id: vlog._id,
      title: vlog.title,
      description: vlog.description,
      file: null,
      previewUrl: vlog.imageUrl
    });
    setIsEditModalOpen(true);
  };
  const handleEditChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "file" && files.length > 0) {
      setEditForm((prev) => ({
        ...prev,
        file: files[0],
        previewUrl: URL.createObjectURL(files[0])
      }));
    } else {
      setEditForm((prev) => ({ ...prev, [name]: value }));
    }
  };
  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("title", editForm.title);
      formData.append("description", editForm.description);
      if (editForm.file) formData.append("vlog", editForm.file);

      const res = await fetchWithAuth(`${API_URL}/update-vlog/${editForm.id}`, {
        method: "PUT",
        body: formData
      });

      if (!res.ok) throw new Error("Failed to update vlog");

      const data = await res.json();
      setVlogs((prev) =>
        prev.map((v) => (v._id === editForm.id ? data.vlog : v))
      );
      setIsEditModalOpen(false);
      toast.success("🎥 Vlog updated successfully");
    } catch (err) {
      console.error(err);
      toast.error("Error in updating vlog, try again");
    }
  };
  const handleCancelBooking = async () => {
    if (!acceptTerms) {
      toast.error("Please accept Terms & Conditions first");
      return;
    }
    const booking = bookings[currentBookingIndex];
    try {
      const res = await fetchWithAuth(`${API_URL}/cancel-booking/${booking._id}`, {
        method: "PUT"
      });
      if (res.ok) {
        const data = await res.json();
        toast.info("❌ Booking cancelled");
        // Prepare email to guide
        const subject = "Booking Cancelled - Soulful Yatra";
        const message = `
  Hello ${booking.guideName || "Guide"},
  
  ⚠️ A booking has been cancelled.
  
  Traveler Name: ${booking.userName}  
  Traveler Email: ${booking.userEmail}  
  Trip Date: ${new Date(booking.date).toLocaleDateString()}  
  Total Cost: ₹${booking.totalCost || 0}
  
  Please update your schedule accordingly.
  
  Thanks,  
  Team TripYatra
  `;

        sendEmail(booking.guideEmail, subject, message);
        setBookings(prev => prev.map(b => (b._id === data.booking._id ? data.booking : b)));
      } else {
        toast.error("Error cancelling booking");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error cancelling booking");
    } finally {
      setShowCancelModal(false);
      setAcceptTerms(false);
    }
  };

  // Handle Change Booking Date
  const handleChangeBookingDate = async () => {
    if (!newDate) {
      toast.error("Please select a new date");
      return;
    }

    const booking = bookings[currentBookingIndex];
    try {
      const res = await fetchWithAuth(
        `${API_URL}/change-booking-date/${booking._id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ newDate }),
        }
      );

      if (res.ok) {
        const data = await res.json();

        // Update local bookings state
        setBookings((prev) =>
          prev.map((b) => (b._id === data.booking._id ? data.booking : b))
        );

        toast.success("📅 Booking date updated");

        // Send email notification to guide
        const subject = "Booking Date Changed - Soulful Yatra";
        const message = `
  Hello ${booking.guideName || "Guide"},
  
  ⚠️ The date for a booking has been changed.
  
  Traveler Name: ${booking.userName}  
  Traveler Email: ${booking.userEmail}  
  Old Trip Date: ${new Date(booking.date).toLocaleDateString()}  
  New Trip Date: ${new Date(newDate).toLocaleDateString()}  
  
  Please update your schedule accordingly.
  
  Thanks,  
  Team TripYatra
  `;
        //console.log(booking);
        sendEmail(booking.guideEmail, subject, message);

      } else {
        const errData = await res.json();
        toast.error(errData.error || "Error updating date");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error updating booking");
    } finally {
      setShowDateModal(false);
      setNewDate("");
    }
  };

  const handleDeleteBooking = async (bookingId) => {
    if (!window.confirm("Are you sure you want to delete this booking?")) return;

    try {
      // Find the booking object
      const booking = bookings.find((b) => b._id === bookingId);
      if (!booking) throw new Error("Booking not found");

      // Call backend to delete booking
      const res = await fetchWithAuth(`${API_URL}/delete-booking/${bookingId}`, {
        method: "DELETE",
      });

      if (!res.ok) {
        const errData = await res.json();
        toast.error(errData.error || "Failed to delete booking");
        return;
      }

      // Remove booking from state
      setBookings((prev) => prev.filter((b) => b._id !== bookingId));
      toast.success("❌ Booking deleted successfully");



    } catch (err) {
      console.error(err);
      toast.error("Error deleting booking, try again");
    }
  };

  useEffect(() => {
    emailjs.init("ZOyRJm9HRzFURhE8Z");
  }, []);

  const sendEmail = (email, subject, message) => {
    emailjs
      .send("service_vwckm3m", "template_z0yrbwk", {
        email: email,
        message: message,
        subject: subject,
      })
      .then((response) => {
        console.log("Email sent successfully:", response.status, response.text);
      })
      .catch((error) => {
        console.error("Error sending email:", error);
      });
  };
  if (authLoading || loading)
    return (
      <div className="profile-main-container">
        <Navbar />
        <div className="loading-destinations">
          <div className="loading-spinner"></div>
          <p>Loading your profile....</p>
        </div>
        <Footer />
      </div>
    );

  if (error)
    return (
      <div className="profile-main-container">
        <Navbar />
        <div className="profile-container">
          <div className="profile-error">
            <h2 className="profile-heading">Error Loading Profile</h2>
            <p>{error}</p>
            <button onClick={() => window.location.reload()} className="retry-btn">
              Retry
            </button>
          </div>
        </div>
        <Footer />
      </div>
    );

  return (
    <div className="profile-main-container">
      <Navbar />
      <div className="profile-container">
        <div className="profile-info">
          <div className="profile-picture">
            <img src={profileImageUrl} alt="Profile" />
            <input
              type="file"
              id="profileImageInput"
              style={{ display: "none" }}
              accept="image/*"
              onChange={(e) => handleProfileImageChange(e.target.files[0])}
            />
            <button
              className="edit-btn"
              onClick={() => document.getElementById("profileImageInput").click()}
            >
              🖊️
            </button>
          </div>
          <h2>{profile?.name}</h2>
          <p>{profile?.email}</p>
        </div>

        {/* Saved Trips Section */}
        <div className="profile-trips-vlogs">
          <h3 className="profile-subheading">Your Saved Trips</h3>
          {trips.length === 0 ? (
            <div className="no-content">
              <div className="no-content-icon">✈️</div>
              <h3>No trips saved yet</h3>
              <p>Start planning your first adventure!</p>
              <button className="no-content-btn" onClick={() => navigate("/plan-trip")}>
                Plan Your First Trip
              </button>
            </div>
          ) : (
            <div className="saved-trips-carousel">
              <button
                className="nav-btn left"
                onClick={() =>
                  setCurrentTripIndex(
                    currentTripIndex === 0 ? trips.length - 1 : currentTripIndex - 1
                  )
                }
              >
                ‹
              </button>
              <div className="saved-trip-card">
                <h4>{trips[currentTripIndex].destination}</h4>
                <p>{trips[currentTripIndex].days} days</p>
                <p>Saved at:
                  {new Date(trips[currentTripIndex].savedAt).toLocaleString("en-IN", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </p>

                <div className="trip-buttons">
                  <button
                    className="view-btn"
                    onClick={() =>
                      setExpandedTrip(
                        expandedTrip === currentTripIndex ? null : currentTripIndex
                      )
                    }
                  >
                    {expandedTrip === currentTripIndex ? "Hide Plan" : "View More"}
                  </button>

                  {deletePrompt === trips[currentTripIndex]._id ? (
                    <span className="delete-confirmation">
                      Do you want to delete it?
                      <button
                        className="confirm-btn"
                        onClick={() =>
                          handleConfirmDelete(trips[currentTripIndex]._id)
                        }
                      >
                        Yes
                      </button>
                      <button className="cancel-btn" onClick={handleCancelDelete}>
                        No
                      </button>
                    </span>
                  ) : (
                    <button
                      className="delete-btn"
                      onClick={() =>
                        handleDeleteClick(trips[currentTripIndex]._id)
                      }
                    >
                      Delete Trip
                    </button>
                  )}
                </div>

                {expandedTrip === currentTripIndex && (
                  <div className="trip-details">
                    {trips[currentTripIndex].tripData?.map((day, dIdx) => (
                      <div key={dIdx} className="trip-day">
                        <h5>{day.day}</h5>
                        <ul>
                          {day.activities.map((act, aIdx) => (
                            <li key={aIdx}>
                              <strong>{act.time}:</strong> {act.activity}
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <button
                className="nav-btn right"
                onClick={() =>
                  setCurrentTripIndex(
                    currentTripIndex === trips.length - 1 ? 0 : currentTripIndex + 1
                  )
                }
              >
                ›
              </button>
            </div>
          )}
          {/* ==========================
              BOOKINGS SECTION
          ========================== */}
          <h3 className="profile-subheading">Your Trip Bookings</h3>
          {bookings.length === 0 ? (
            <div className="no-content">
              <div className="no-content-icon">🧳</div>
              <h3>No bookings yet</h3>
              <p>Book a guide and start your journey!</p>
              <button className="no-content-btn" onClick={() => navigate("/book-guide")}>
                Book a Guide
              </button>
            </div>
          ) : (
            <div className="saved-trips-carousel">
              <button
                className="nav-btn left"
                onClick={() =>
                  setCurrentBookingIndex(
                    currentBookingIndex === 0 ? bookings.length - 1 : currentBookingIndex - 1
                  )
                }
              >
                ‹
              </button>

              <div className="saved-trip-card">
                <h4>Guide: {bookings[currentBookingIndex].guideEmail}</h4>
                <p>Date: {new Date(bookings[currentBookingIndex].date).toLocaleDateString()}</p>
                <p>Price: ₹{bookings[currentBookingIndex].price}</p>
                <p>Paid: ₹{bookings[currentBookingIndex].paidAmount}</p>
                <p>Status: {bookings[currentBookingIndex].status}</p>

                <div className="trip-buttons">
                  {["Cancelled", "Rejected", "Completed"].includes(bookings[currentBookingIndex].status) ? (
                    <button
                      className="delete-btn"
                      onClick={() => handleDeleteBooking(bookings[currentBookingIndex]._id)}
                    >
                      Delete Booking
                    </button>
                  ) : (
                    <>
                      <button className="delete-btn" onClick={() => setShowCancelModal(true)}>Cancel</button>
                      <button className="change-date-btn" onClick={() => setShowDateModal(true)}>Change Date</button>
                      {/* Mark as Completed button */}
                      {bookings[currentBookingIndex].status === "Confirmed" &&
                        new Date(bookings[currentBookingIndex].date).setHours(0, 0, 0, 0) <
                        new Date().setHours(0, 0, 0, 0) && (
                          <button
                            className="save-btn"
                            onClick={async () => {
                              try {
                                const res = await fetchWithAuth(
                                  `${API_URL}/complete-booking/${bookings[currentBookingIndex]._id}`,
                                  { method: "PUT" }
                                );
                                if (!res.ok) throw new Error("Failed to mark completed");

                                const data = await res.json();
                                setBookings(prev =>
                                  prev.map(b => (b._id === data.booking._id ? data.booking : b))
                                );
                                toast.success("✅ Trip marked as Completed");
                              } catch (err) {
                                console.error(err);
                                toast.error("Error marking trip as Completed");
                              }
                            }}
                          >
                            Mark as Completed
                          </button>
                        )}

                    </>
                  )}
                </div>
              </div>

              <button
                className="nav-btn right"
                onClick={() =>
                  setCurrentBookingIndex(
                    currentBookingIndex === bookings.length - 1 ? 0 : currentBookingIndex + 1
                  )
                }
              >
                ›
              </button>
            </div>

          )}


          {/* Cancel Booking Modal */}
          {showCancelModal && (
            <div className="modal-overlay">
              <div className="modal-content">
                <h2>Cancel Booking</h2>
                <p>Please read and accept the Terms & Conditions before cancelling:</p>
                <ul className="tac-list">
                  <li>Full refund if cancellation is made 7 days before the trip.</li>
                  <li>50% of advance payment will be refunded if cancelled at least 48 hours before the trip.</li>
                  <li>No refund if cancelled within 48 hours of the trip.</li>
                  <li>If the guide cancels, full advance will be refunded.</li>
                  <li>Date changes are allowed up to 3 days before the trip, subject to guide availability.</li>
                </ul>
                <label>
                  <input
                    type="checkbox"
                    checked={acceptTerms}
                    onChange={(e) => setAcceptTerms(e.target.checked)}
                  />{" "}
                  I accept the Terms & Conditions
                </label>
                <div className="modal-actions">
                  <button
                    className="delete-btn"
                    onClick={handleCancelBooking}
                    disabled={!acceptTerms}
                  >
                    Cancel
                  </button>
                  <button className="close-btn" onClick={() => setShowCancelModal(false)}>
                    Close
                  </button>
                </div>
              </div>
            </div>
          )}


          {/* Change Date Modal */}
          {showDateModal && (
            <div className="modal-overlay">
              <div className="modal-content">
                <h2>Change Booking Date</h2>
                <input
                  type="date"
                  value={newDate}
                  onChange={(e) => setNewDate(e.target.value)}
                />
                <div className="modal-actions">
                  <button className="save-btn" onClick={handleChangeBookingDate}>Update</button>
                  <button className="close-btn" onClick={() => setShowDateModal(false)}>Close</button>
                </div>
              </div>
            </div>
          )}
          {/* User Vlogs */}
          <h3 className="profile-subheading">Your Vlogs</h3>
          {vlogs.length === 0 ? (
            <div className="no-content">
              <div className="no-content-icon">🎥</div>
              <h3>No vlogs yet</h3>
              <p>Start sharing your travel experiences with the world!</p>
              <button className="no-content-btn" onClick={() => navigate("/vlogs")}>
                Create Your First Vlog
              </button>
            </div>
          ) : (
            <div className="saved-trips-carousel">
              <button
                className="nav-btn left"
                onClick={() =>
                  setCurrentVlogIndex(
                    currentVlogIndex === 0 ? vlogs.length - 1 : currentVlogIndex - 1
                  )
                }
              >
                ‹
              </button>

              <div className="saved-trip-card">
                <h4>{vlogs[currentVlogIndex].title}</h4>
                <img
                  src={vlogs[currentVlogIndex].imageUrl}
                  alt={vlogs[currentVlogIndex].title}
                  style={{ width: "100%", borderRadius: "12px" }}
                />

                <p>{vlogs[currentVlogIndex].description}</p>

                {/* Likes & Comments */}

                <div className="vlog-actions">
                  {/* Likes */}
                  <div className="action-item">
                    <svg
                      className="like-icon"
                      viewBox="0 0 24 24"
                      fill="red"
                      stroke="red"
                      strokeWidth="2"
                    >
                      <path d="M12 21s-6.7-5.4-8.2-7C2 12.1 1.6 8.7 4.2 6.7 6.1 5.2 9 6.8 12 10c3-3.2 5.9-4.8 7.8-3.3 2.6 2 .2 5.4-.8 7.3C18.7 15.6 12 21 12 21z" />
                    </svg>
                    <span className="action-label">{vlogs[currentVlogIndex]?.likeCount || 0}</span>
                  </div>

                  {/* Comments */}
                  <div
                    className="action-item comment-item"
                    onClick={() => handleToggleComments(currentVlogIndex)}
                  >
                    <svg
                      className="comment-icon"
                      fill="none"
                      stroke="#000"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                    >
                      <path d="M21 15.5a2.5 2.5 0 0 1-2.5 2.5H7l-4 4V5.5A2.5 2.5 0 0 1 5.5 3h13A2.5 2.5 0 0 1 21 5.5z" />
                    </svg>
                    <span className="action-label">{vlogs[currentVlogIndex]?.comments?.length || 0}</span>
                  </div>
                </div>
                {/* ✏️ Edit Button */}
                <div className="vlog-ops">
                  <button
                    className="edit-vlog-btn"
                    onClick={() => handleEditVlog(vlogs[currentVlogIndex])}
                  >
                    Edit
                  </button>

                  {/* 🗑️ Delete Button */}
                  <button
                    className="delete-btn"
                    onClick={() => handleDeleteVlog(vlogs[currentVlogIndex]._id)}
                  >
                    Delete
                  </button>
                </div>

                {isEditModalOpen && (
                  <div className="modal-overlay">
                    <div className="modal-content">
                      <h2>Edit Vlog</h2>
                      <form onSubmit={handleEditSubmit}>
                        <label>Title:</label>
                        <input
                          type="text"
                          name="title"
                          value={editForm.title}
                          onChange={handleEditChange}
                          className="edt-title"
                        />

                        <label>Description:</label>
                        <textarea
                          name="description"
                          value={editForm.description}
                          onChange={handleEditChange}
                        />

                        <label>Change Image:</label>
                        <input type="file" name="file" accept="image/*" onChange={handleEditChange} />

                        {editForm.previewUrl && (
                          <img src={editForm.previewUrl} alt="Preview" className="preview-img" />
                        )}

                        <div className="modal-actions">
                          <button type="submit" className="save-btn">Save</button>
                          <button type="button" className="delete-btn" onClick={() => setIsEditModalOpen(false)}>
                            Cancel
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                )}

                {showComments === currentVlogIndex && (
                  <div className="vlog-comments">
                    {vlogs[currentVlogIndex]?.comments?.map((c) => (
                      <div key={c._id} className="vlog-comment">
                        <strong>{c.userName}:</strong> {c.text}
                      </div>
                    ))}
                    {vlogs[currentVlogIndex]?.comments?.length === 0 && (
                      <p className="no-comments">No comments yet.</p>
                    )}
                  </div>
                )}
              </div>

              <button
                className="nav-btn right"
                onClick={() =>
                  setCurrentVlogIndex(
                    currentVlogIndex === vlogs.length - 1 ? 0 : currentVlogIndex + 1
                  )
                }
              >
                ›
              </button>

            </div>
          )}
        </div>
      </div>
      <Footer />
    </div >
  );
}

export default Profile;
